export default __webpack_public_path__ + "static/media/like.92e21bf0.svg";